import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const TimeLineChartContainer = styled.div`
  height: ${pxToRem('444px')};
`;
